import React, {useEffect, useState} from 'react';
import {Outlet} from 'react-router-dom';
import storeUtils from '../../utils/storeUtils';
import CookieStatement from './header/CookieStatement';
import Auth from '../auth';
import classnames from 'classnames';
import {useTranslation} from 'react-i18next';

export default () => {
  const {i18n} = useTranslation();
  const [hideStatement, setHideStatement] = useState(true);
  useEffect(() => {
    if (window.navigator.userAgent === 'ReactSnap') {
      return;
    }
    setHideStatement(storeUtils.getCookieStatement());
  }, []);
  return (
    <Auth>
      <div
        className={classnames({
          'pf-language': true,
          'pf-language-ja': i18n.language === 'ja',
        })}
      >
        <Outlet />
        <CookieStatement
          hideStatement={!!hideStatement}
          setHideStatement={setHideStatement}
        />
      </div>
    </Auth>
  );
};
